export default __webpack_public_path__ + "364c55056b0216c180f3ac9b6fd50311.jpg";